import React, { useCallback } from 'react';

// Hooks
import { useReducer } from 'react';

// Components
import ToastsContainer from '../components/Globals/ToastsContainer/ToastsContainer';

// Interfaces
import { IToast } from '../interfaces/Toast';
interface ToastsState {
    success: (message: IToast['message']) => void;
    warning: (message: IToast['message']) => void;
    info: (message: IToast['message']) => void;
    error: (message: IToast['message']) => void;
    remove: (id: IToast['id']) => void;
}
type ToastsAction =
    { type: 'ADD_TOAST', payload: IToast } |
    { type: 'DELETE_TOAST', payload: IToast['id'] };


const ToastContext = React.createContext<ToastsState>({
    success: () => {/**/ }, warning: () => {/**/ },
    info: () => {/* */ }, error: () => {/* */ },
    remove: () => {/* */ }
});

const toastReducer = (toasts: IToast[], action: ToastsAction) => {
    if (action.type === 'ADD_TOAST')
        return [...toasts, action.payload];
    if (action.type === 'DELETE_TOAST') {
        return toasts.filter(toast =>
            toast.id !== action.payload);
    }
    return toasts;
};

export const ToastContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [toasts, dispatch] = useReducer(toastReducer, []);

    const addToast = useCallback((type: IToast['type'], message: IToast['message']) => {
        const id = crypto.randomUUID();
        dispatch({ type: 'ADD_TOAST', payload: { id, message, type } });
    }, []);

    const success = useCallback((message: IToast['message']) => {
        return addToast('success', message)
    }, [addToast]);

    const warning = useCallback((message: IToast['message']) => {
        return addToast('warning', message);
    }, [addToast])

    const info = useCallback((message: IToast['message']) => {
        return addToast('info', message);
    }, [addToast])

    const error = useCallback((message: IToast['message']) => {
        return addToast('error', message);
    }, [addToast])

    const remove = useCallback((id: IToast['id']) => {
        dispatch({ type: 'DELETE_TOAST', payload: id });
    }, []);

    const initValue = { success, warning, info, error, remove };

    return (
        <ToastContext.Provider value={initValue}>
            <ToastsContainer toasts={toasts} />
            {children}
        </ToastContext.Provider>
    );
};
export default ToastContext;
